import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import OrganisationSKUModal from '../OrganisationSKU/OrganisationSKUModal'
import withAccordionControl from '../../Accordion/withAccordionControl'
import {
  fetchShopCollection,
  selectShopProducts,
} from '../../../reducers/Organisation/organisationShopReducer'

import OrganisationProductsItem from './OrganisationProductsItem'
import OrganisationProductsModal from './OrganisationProductsModal'

const OrganisationProducts = ({ accordionToggle, accordionOpened }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()

  const products = useSelector(selectShopProducts) || []

  useEffect(() => {
    dispatch(fetchShopCollection())
  }, [dispatch])

  return (
    <div className="ctp-shop-list">
      {products.length > 0 &&
        products.map((product) => (
          <OrganisationProductsItem
            key={product.id}
            productData={product}
            isExpanded={product.id === accordionOpened}
            onClick={() => accordionToggle(product.id)}
          />
        ))}
      <OrganisationProductsModal params={params} />
      <OrganisationSKUModal
        params={params}
        parentCategory="Product"
        onModalClose={() => navigate('/dashboard/organisation/products')}
      />
    </div>
  )
}

export default withAccordionControl(OrganisationProducts, 'multiple')
